<div class="bg-form-content p-4">
        <label *ngIf="showTitle" class="mb-3" >{{"Update Password"|translate}}</label>
    <form class="change-password-form"  ngForm [formGroup]="updateForm" (ngSubmit)="onSubmit($event)" novalidate>
      <div class="field-group mb-3">
        <label>{{"Current Password"|translate}}</label>
        <input type="password" formControlName="old_password" (blur)="verifyPassword($event)" class="form-control" value="" />
        <ng-container>
          <small class="form-error text-danger" *ngIf="updateForm.controls.old_password.touched && updateForm.controls.old_password.errors?.required">
            {{"Please enter current password"|translate}}.
          </small>
          <small class="form-error text-danger" *ngIf="updateForm.controls.old_password.touched && updateForm.controls.old_password.errors?.minlength">
            {{"Please enter valid current password"|translate}}.
          </small>
        </ng-container>
      </div>
      <div class="field-group mb-3">
        <label>{{"New Password"|translate}}</label>
        <input type="password" formControlName="password" (keyup)="verifyPassword($event)" class="form-control" value="" />
        <ng-container>
          <small class="form-error text-danger" *ngIf="updateForm.controls.password.touched && updateForm.controls.password.errors?.required">
            {{"Please enter password"|translate}}.
          </small>
          <small class="form-error text-danger" *ngIf="updateForm.controls.password.touched && updateForm.controls.password.errors?.minlength">
            {{"Password must be of minimum 8 characters"|translate}}.
          </small>
          <small class="form-error text-danger" *ngIf="updateForm.controls.password.touched && updateForm.controls.password.hasError('passwordStrength')">
            {{"Password must contain one number, one upper case, one lower case character and one special character"|translate}}.
          </small>
          <small class="form-error text-danger" *ngIf="updateForm.controls.password.touched && updateForm.controls.password.errors?.maxlength">
            {{"Password must be of maximum 16 characters"|translate}}.
          </small>
          <small class="form-error text-danger" *ngIf="updateForm.controls.password.touched && updateForm.controls.password.hasError('whitespace')">
            {{"Whitespace not allowed in password"|translate}}.
          </small>
        </ng-container>
      </div>
      <div class="field-group mb-3">
        <label>{{"Confirm Password"|translate}}</label>
        <input type="password" name="password_confirmation" (keyup)="verifyPassword($event)"  formControlName="password_confirmation" class="form-control" value="" />
        <ng-container >
          <small class="form-error text-danger" *ngIf="updateForm.controls.password_confirmation.touched && updateForm.controls.password_confirmation.errors?.required">
            {{"Please enter password"|translate}}.
          </small>
          <small class="form-error text-danger" *ngIf="updateForm.controls.password_confirmation.touched && updateForm.controls.password_confirmation.errors?.minlength">
            {{"Password must be of minimum 8 characters"|translate}}.
          </small>
          <small class="form-error text-danger" *ngIf="updateForm.controls.password_confirmation.touched && updateForm.controls.password_confirmation.hasError('passwordStrength')">
            {{"Password must contain one number, one upper case, one lower case character and one special character"|translate}}.
          </small>
          <small class="form-error text-danger" *ngIf="updateForm.controls.password_confirmation.touched && updateForm.controls.password_confirmation.errors?.maxlength">
             {{"Password must be of maximum 16 characters"|translate}}.
          </small>
          <small class="form-error text-danger" *ngIf="updateForm.controls.password_confirmation.touched && updateForm.controls.password_confirmation.errors?.matched">
             {{"Confirm Password and Password mismatch"|translate}}.
          </small>
          <small class="form-error text-danger" *ngIf="updateForm.controls.password_confirmation.touched && updateForm.controls.password_confirmation.hasError('whitespace')">
             {{"Whitespace not allowed in password"|translate}}.
          </small>
        </ng-container>
      </div>
      <div class="mt-3" >
        <small class="form-error text-danger" *ngIf="errorArr?.length">
          <div *ngFor="let item of errorArr; let i=index;" class="mt-3">
            <li>{{item}}</li>          
          </div>
        </small>
        <small class="lms-text-light-green" *ngIf="verifiedMessage">
          <div class="mt-3">
            <li>{{verifiedMessage}}</li>          
          </div>
        </small>
      </div>
      <div class="mt-3">
        <button [disabled]="disableSubmit" type="submit" class="btn btn-primary d-block w-100 text-uppercase">
          {{"Update Password"|translate}}
        </button>
      </div>
    </form>
  </div>
